var _g, _line, _path, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect, _path37, _rect2, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 562,
    viewBox: "0 0 646 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 46.229,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 0 131.92)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    y1: -1.5,
    x2: 52.4334,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 24.1896 177.269)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 20.1545 140.989)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 60.3416 121.041)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.44,
    y1: -1.5,
    x2: 105.962,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 54.6961 104.77)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 46.229,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 0 384.535)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.44,
    y1: -1.5,
    x2: 105.962,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 54.6961 357.384)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35.8883,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 171.456 46.8113)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 160.404 52.2979)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 99.8362 101.437)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 76.8121 151.148)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 37.1657,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 88.7313 145.232)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    y1: -1.5,
    x2: 42.4881,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 196.538 91.717)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 42.4273,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 142.822 118.381)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 130.933 124.283)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 186.204 96.8477)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 245.045 67.6399)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 258.401 61.0088)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 272.796 53.8635)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 14.8419,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 112.157 95.3188)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 45.265 186.98)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 21.8979,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 85.4521 167.031)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 113.837 152.941)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 202.326 109.015)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 322.772 49.2256)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 333.366 43.968)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 344.191 38.595)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 354.322 33.5657)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    y1: -1.5,
    x2: 31.6304,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122631 0.93987 126.214 146.795)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 45.2676 206.463)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 85.4543 186.514)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 124.949 166.909)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 25.9126,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 137.27 160.792)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 31.6304,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 206.822 126.268)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 65.6938,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 245.049 107.292)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 311.029 74.5403)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 334.29 62.9934)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 322.775 68.7104)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 346.035 57.1631)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 357.492 51.4773)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 5.7178,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 368.086 46.2175)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 45.2701 225.946)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.3335,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 85.4572 205.997)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 6.69104,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 124.952 186.392)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 10.5935,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 173.646 162.221)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 16.5603,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 292.711 103.118)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 9.86928,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 313.435 92.8313)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.8202,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 137.273 180.277)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.9608,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 162.582 128.743)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.9608,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 217.97 101.249)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 65.8858,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 256.725 82.012)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.4552,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 168.016 145.531)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 33.8202,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 188.4 154.898)",
    stroke: "#378AFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 66.3021,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 226.399 136.036)",
    stroke: "#378AFF",
    strokeWidth: 3
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 44.4042,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 45.2752 264.365)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0986 340.053V250.09L458.667 40.8381V130.801L32.0986 340.053Z",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 81.2657,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 78.0943 267.558)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 54.5015,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 78.0967 287.041)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 31.771,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 172.041 240.408)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 31.771,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 220.42 216.393)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 38.9297,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 268.552 192.501)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 7.29931,
    y2: -1.5,
    transform: "matrix(0.946523 -0.469829 0.000122716 0.93987 207.295 222.909)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 7.29931,
    y2: -1.5,
    transform: "matrix(0.946523 -0.469829 0.000122716 0.93987 254.33 199.56)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 55.4748,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 202.11 205.997)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 9.85407,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 178.159 217.886)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 9.85407,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 190.364 211.827)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 104.319,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 258.762 177.876)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 68.5527,
    y2: -1.5,
    transform: "matrix(0.946515 -0.469845 0.00012271 0.93987 362.913 126.176)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 15.876,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 432.005 91.8799)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 44.4042,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 95.9973 239.186)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.75918,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 146.719 214.009)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.75918,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 159.733 207.549)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.75918,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 47.125 321.627)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.75918,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 24.2127 353.309)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.75918,
    y2: -1.5,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 172.036 201.442)",
    stroke: "#378AFF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.3 34.1207L290.364 38.6526L356.693 5.53194L347.629 1L281.3 34.1207Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.3 84.2054L290.271 88.6906V38.8983L281.3 34.4131V84.2054Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M290.272 88.5722L356.683 55.3664V5.55786L290.272 38.7636V88.5722Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.992 344.923L158.828 354.341L296.668 285.512L277.832 276.094L139.992 344.923Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.992 464.549L158.634 473.87V354.203L139.992 344.882V464.549Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.634 473.626L296.646 404.62V285.351L158.634 354.357V473.626Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8782 159.207L102.714 168.625L240.554 99.7959L221.718 90.3779L83.8782 159.207Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8775 296.322L102.519 305.643V168.488L83.8775 159.167V296.322Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.519 305.644L240.532 236.638V99.8511L102.519 168.857V305.644Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M220.033 469.198V204.077L545.393 41.3967V306.518L220.033 469.198Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.348 214.692C234.324 213.436 234.498 211.938 233.738 211.347C232.977 210.756 231.569 211.295 230.593 212.551C229.617 213.807 229.442 215.304 230.203 215.895C230.964 216.487 232.372 215.948 233.348 214.692Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.322 210.121C243.298 208.865 243.472 207.368 242.711 206.776C241.951 206.185 240.543 206.724 239.567 207.98C238.591 209.236 238.416 210.733 239.177 211.325C239.938 211.916 241.346 211.377 242.322 210.121Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.294 205.551C252.27 204.295 252.444 202.798 251.683 202.206C250.922 201.615 249.514 202.154 248.538 203.41C247.562 204.666 247.388 206.163 248.149 206.755C248.91 207.346 250.318 206.807 251.294 205.551Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.117 233.483L297.428 202.327",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.238 284.48V263.862L262.021 250.97V271.589L236.238 284.48Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.238 312.174V291.556L262.021 278.664V299.282L236.238 312.174Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M236.238 339.867V319.249L262.021 306.358V326.976L236.238 339.867Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M500.004 104.557V83.9252L525.787 71.0337V91.6656L500.004 104.557Z",
    fill: "white",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M500.003 99.806L525.786 86.9146",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.003 95.0534L525.786 82.1619",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M500.003 89.6671L525.786 76.7756",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M500.003 95.0534V84.032L513.776 77.1455V88.1669L500.003 95.0534Z",
    fill: "white",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M501.633 86.9268L511.51 81.9883",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M501.633 90.2108L511.51 85.2722",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M449.921 151.869L496.992 128.333",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M449.921 170.606L524.871 133.132",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M449.921 179.026L524.871 141.552",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M449.921 187.446L524.871 149.971",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M449.924 234.784L524.873 196.941V215.414L449.924 253.278V234.784Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M454.667 242.191L461.434 238.812",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M458.047 237.443V243.774",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M449.923 208.449L524.873 170.606V189.079L449.923 226.943V208.449Z",
    fill: "white",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M568.348 231.352C567.452 230.801 566.351 230.755 565.41 231.214L503.114 262.362C502.081 262.867 501.438 263.923 501.438 265.071V389.639C501.438 390.695 501.989 391.659 502.884 392.21C503.366 392.508 503.917 392.669 504.468 392.669C504.927 392.669 505.386 392.554 505.822 392.348L568.118 361.2C569.151 360.695 569.794 359.639 569.794 358.491V233.923C569.794 232.89 569.243 231.903 568.348 231.352Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M507.496 266.815L569.792 235.69V360.258L507.496 391.383V266.815Z",
    fill: "white",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M540.703 368.151C542.197 366.229 542.466 363.939 541.305 363.037C540.144 362.135 537.992 362.961 536.498 364.883C535.005 366.805 534.735 369.094 535.896 369.997C537.058 370.899 539.21 370.072 540.703 368.151Z",
    fill: "#EFF5F8",
    stroke: "#28234A",
    strokeWidth: 1.06896,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.32811,
    height: 15.8909,
    rx: 3.16405,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 321.48 36.2905)",
    fill: "#EFF5F8",
    stroke: "#28234A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M331.42 42.4535C331.42 47.0218 328.313 52.2679 324.479 54.171C320.645 56.0741 317.537 53.9135 317.536 49.3452",
    stroke: "#28234A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.29051,
    height: 4.74139,
    transform: "matrix(0.946516 -0.469843 0.000122711 0.93987 323.869 55.1755)",
    fill: "#28234A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.114 215.187L157.937 211.378L157.935 195.48L171.109 178.327L184.659 182.218L184.661 198.108L171.114 215.187Z",
    fill: "white",
    stroke: "#28234A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.111 199.562L171.111 215.118",
    stroke: "#28234A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.426 294.179L199.892 285.939",
    stroke: "#056DFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M191.651 279.533V300.57",
    stroke: "#056DFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M543.63 274.26L587.378 172.183L645.708 143.018",
    stroke: "#378AFF",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M645.706 122.699V137.282L587.376 166.447V151.864L645.706 122.699Z",
    fill: "#378AFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M232.385 523.159C237.223 511.362 235.328 499.413 228.154 496.472C220.98 493.53 211.243 500.71 206.406 512.507C201.568 524.305 203.463 536.253 210.637 539.194C217.811 542.136 227.548 534.957 232.385 523.159Z",
    fill: "#378AFF",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 497.461V517.833L230.565 497.782C227.705 495.589 223.748 495.282 219.363 497.461Z",
    fill: "white",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M211.475 555.907L223.359 549.972",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M227.315 548.007L235.242 544.05",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M211.475 561L227.316 553.1",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M279.052 497.84C283.889 486.042 281.995 474.094 274.821 471.153C267.647 468.211 257.909 475.39 253.072 487.188C248.235 498.985 250.13 510.933 257.304 513.875C264.478 516.816 274.215 509.637 279.052 497.84Z",
    fill: "#378AFF",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M277.138 472.282C274.215 469.997 270.19 469.685 265.743 471.901V492.624L277.138 501.599C280.104 496.41 281.726 490.563 281.857 484.588C281.857 478.85 280.048 474.58 277.138 472.282Z",
    fill: "white",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M254.185 530.808L277.94 518.951",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M254.185 535.902L266.069 529.98",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.848 455.992L300.848 455.992C303.722 450.885 307.679 446.621 312.05 444.442V464.814L312.051 464.814L312.05 464.814L296.21 472.715C296.338 466.841 297.933 461.092 300.848 455.992Z",
    fill: "#378AFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M300.848 455.992L300.412 455.746L300.202 456.12L300.539 456.385L300.848 455.992ZM300.848 455.992L301.282 456.24L301.497 455.865L301.157 455.599L300.848 455.992ZM312.05 444.442H312.55V443.634L311.827 443.994L312.05 444.442ZM312.05 464.814H311.55V465.057L311.741 465.207L312.05 464.814ZM312.051 464.814L312.305 465.245L312.935 464.873L312.36 464.421L312.051 464.814ZM312.05 464.814L312.274 465.262L312.289 465.254L312.304 465.245L312.05 464.814ZM296.21 472.715L295.71 472.704L295.692 473.532L296.433 473.162L296.21 472.715ZM300.539 456.385L300.539 456.385L301.157 455.599L301.157 455.599L300.539 456.385ZM311.827 443.994C307.34 446.231 303.319 450.583 300.412 455.746L301.284 456.237C304.126 451.187 308.018 447.01 312.273 444.889L311.827 443.994ZM312.55 464.814V444.442H311.55V464.814H312.55ZM312.36 464.421L312.359 464.421L311.741 465.207L311.742 465.207L312.36 464.421ZM312.304 465.245L312.305 465.245L311.797 464.383L311.797 464.384L312.304 465.245ZM296.433 473.162L312.274 465.262L311.827 464.367L295.987 472.267L296.433 473.162ZM300.414 455.744C297.457 460.917 295.84 466.747 295.71 472.704L296.71 472.725C296.836 466.935 298.408 461.268 301.282 456.24L300.414 455.744Z",
    fill: "#28234A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M323.266 444.83C320.392 442.571 316.435 442.263 312.051 444.442V464.815L296.21 472.715C296.21 478.343 297.988 482.554 300.848 484.813C303.709 487.072 307.679 487.366 312.051 485.187C316.837 482.515 320.735 478.5 323.266 473.637C326.182 468.537 327.776 462.788 327.905 456.914C327.905 451.286 326.127 447.089 323.266 444.83Z",
    fill: "white",
    stroke: "#28234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M300.167 503.81L304.137 501.845",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M308.094 499.867L323.934 491.966",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M300.167 508.904L319.978 499.038",
    stroke: "#28234A",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M346.204 237.641L353.612 221.713C359.575 208.193 365.177 206.685 372.344 207.285L387.733 208.881C399.629 209.845 424.354 213.519 429.804 214.633C437.188 216.142 438.116 221.339 438.598 224.511C439.05 232.823 438.393 250.441 437.725 256.584C436.821 264.896 433.448 284.14 430.768 291.849C429.607 295.188 422.777 305.943 419.445 310.882L410.595 316.524C408.37 319.154 374.964 331.09 368.67 331.632C366.898 331.784 347.446 332.93 343.554 332.686C336.838 332.264 332.833 331.12 325.846 329.674C320.256 328.518 306.993 323.535 301.059 321.188C294.614 317.742 287.599 314.526 285.462 313.322C281.585 311.137 280.191 306.515 283.082 304.136C286.896 300.997 303.861 292.231 308.74 289.56C311.601 287.994 316.119 284.591 319.461 281.007C321.986 278.3 330.243 270.046 335.995 258.542L346.204 237.641Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M302.958 322.205C302.379 321.894 301.741 321.553 301.059 321.188M409.808 317.025L410.595 316.524M301.059 321.188C294.614 317.742 287.599 314.526 285.462 313.322C281.585 311.137 280.191 306.515 283.082 304.136C286.896 300.997 303.861 292.231 308.74 289.56C311.601 287.994 316.119 284.591 319.461 281.007C321.986 278.3 330.243 270.046 335.995 258.542L346.204 237.641L353.612 221.713C359.575 208.193 365.177 206.685 372.344 207.285L387.733 208.881C399.629 209.845 424.354 213.519 429.804 214.633C437.188 216.142 438.116 221.339 438.598 224.511C439.05 232.823 438.393 250.441 437.725 256.584C436.821 264.896 433.448 284.14 430.768 291.849C429.607 295.188 422.777 305.943 419.445 310.882L410.595 316.524M301.059 321.188C306.993 323.535 320.256 328.518 325.846 329.674C332.833 331.12 336.838 332.264 343.554 332.686C347.446 332.93 366.898 331.784 368.67 331.632C374.964 331.09 408.37 319.154 410.595 316.524",
    stroke: "#28234A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M285.934 409.102L301.972 321.665C301.425 321.371 312.365 325.403 313.028 325.552L313.032 325.536C313.07 325.556 313.067 325.561 313.028 325.552L308.822 342.607L309.906 343.812L349.658 341.643L350.225 332.744L368.149 331.796L381.053 328.31L380.858 339.114L405.673 337.427L406.757 335.259L400.373 320.803L409.287 317.189L445.185 399.103L443.619 400.91L440.005 400.91L435.909 400.91L412.268 348.15L380.978 350.168L383.99 434.399L380.738 435.603L377.606 435.603L376.16 434.399L372.305 369.349L361.524 351.839L356.916 351.975L354.356 378.866L353.272 379.95L349.658 379.95L347.852 378.866L347.129 377.782L348.695 352.605L308.486 355.298C307.586 355.359 306.838 356.013 306.659 356.897L296.058 409.227C295.775 410.626 294.545 411.631 293.118 411.631L288.705 411.631L286.777 410.788L285.934 409.102Z",
    fill: "white",
    stroke: "#28234A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M389.804 239.489L433.552 137.412L491.882 108.247",
    stroke: "#378AFF",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M491.88 87.9282V102.511L433.55 131.676V117.093L491.88 87.9282Z",
    fill: "#378AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.8ff9bc3703eacb6e7a6bf0b16ad431d2.svg";
export { ForwardRef as ReactComponent };